
import './loading-styles.css';

interface LoadingModalProps {
    message: string
}

function LoadingModal(props: LoadingModalProps): JSX.Element {

    return (
        <div className="px-10 py-5 mx-auto text-center bg-white">
            <h1 className="text-center text-2xl font-extrabold text-gray-900">{props.message}</h1>
            <div className="spinner"></div>
        </div>
    );
}

export default LoadingModal;
